exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#projects-logger-page{position:relative;width:100%;height:100%;display:grid;grid-template-columns:var(--outer-gutter-col) repeat(12,1fr) var(--outer-gutter-col);grid-gap:0 var(--gutter)}#projects-logger-page .projects-logger-sidebar{position:relative;grid-column:1/6;overflow:auto;background-color:var(--alt-bg-color)}#projects-logger-page .projects-logger-content{position:relative;grid-column:6/15;overflow:hidden}#projects-logger-page .projects-logger-content .project{position:relative;width:100%;height:100%}", ""]);

// exports
